import React from 'react';
import PropTypes from 'prop-types';

const Checkbox = props => {
  const onChange = event => {
    props.onChange(event);
  };

  const { id = '', label, name, checked, classStyle, disabled, customStyles } = props;
  return (
    <div className={`${classStyle} ${disabled ? 'disabled' : ''} checkbox`}>
      {label && (
        <span className="custom-label" data-id={id}>
          {label}
        </span>
      )}
      <input
        id={id}
        name={name}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        onClick={e => {
          e.stopPropagation();
        }}
      />
      <label htmlFor={id} className={`${label ? 'center' : ''}`} style={customStyles}>
        <span
          className="custom-checkbox"
          onClick={e => {
            e.stopPropagation();
          }}
        />
        <span className="custom-label" data-id={id} />
      </label>
    </div>
  );
};

Checkbox.propTypes = {
  id: PropTypes.any,
  name: PropTypes.string,
  checked: PropTypes.bool,
  classStyle: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.string,
  customStyles: PropTypes.object,
};

Checkbox.defaultProps = {
  classStyle: '',
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js